import React from 'react';
import ComplianceArchiveDetailSection from '../../../sections/AdminDashboard/ComplianceArchive/ComplianceArchiveDetail';

const ComplianceArchiveDetail = () => {
  return <ComplianceArchiveDetailSection />;
};

export default ComplianceArchiveDetail;

